import { TabsTotals } from "@components/Pagination/Pagination.props";
import { NewMinerI } from "@services/addNewMiner";
import { IAdminMinerInfo, IAdminMinerTable } from "@services/getMinerInfo";
import { Tab } from "@store/minersSelect/actionTypes";
import { IAdminMinerTableWithUnknown } from "@utils/hooks/useGetMinerList";

export enum ActionTypesStoredMiners {
  REFRESH_MINER = "STORED_MINERS__REFRESH_MINER",
  SET_MINERS = "STORED_MINERS__SET_MINERS",
  ADD_NEW_MINER = "STORED_MINERS__ADD_NEW_MINER",
  ADD_NEW_MINER_LIST = "STORED_MINERS__ADD_NEW_MINER_LIST",
  CLEAR_MINERS = "STORED_MINERS__CLEAR_MINERS",
  DELETE_MINER = "STORED_MINERS__DELETE_MINER",
  //SET_MINER_INFO = "STORED_MINERS__SET_MINER_INFO",
  SET_OPEN_MINER = "STORED_MINERS__SET_OPEN_MINER",
  SET_REFRESHING = "STORED_MINERS__SET_REFRESHING",
  CLEAR_REFRESHING = "STORED_MINERS__CLEAR_REFRESHING",
}

export interface ActionBaseStoredMiners {
  type: ActionTypesStoredMiners;
  payload?: any;
}

export interface ActionSetMiners extends ActionBaseStoredMiners {
  payload: {
    Miners: IAdminMinerTableWithUnknown[];
    Total: number;
    TabsTotals: TabsTotals,
    AreUnknown?: boolean;
  };
}

export interface ActionRefreshMiner extends ActionBaseStoredMiners {
  payload: IAdminMinerTable;
}

export interface ActionAddNewMiner extends ActionBaseStoredMiners {
  payload: NewMinerI;
}

export interface ActionAddNewMinerList extends ActionBaseStoredMiners {
  payload: NewMinerI[];
}

export interface ActionDeleteMiner extends ActionBaseStoredMiners {
  payload: {
    minerID: string,
    tab: Tab,
  };
}

export interface ActionSetMinerInfo extends ActionBaseStoredMiners {
  payload: {
    info: IAdminMinerInfo;
    isAdmin: boolean;
  };
}

export interface ActionSetOpenMiner extends ActionBaseStoredMiners {
  payload: {
    id: string;
    reset?: boolean;
  };
}

export interface ActionSetRefreshing extends ActionBaseStoredMiners { }
export interface ActionClearRefreshing extends ActionBaseStoredMiners { }
